// PrivateRoute.tsx in v6
import { useSelector } from "react-redux";
import EmptyNavBar from "./EmptyNavBar";
import IgniteFooter from "./IgniteFooter";
import { getSubsite } from "../reducers/auth";

const PublicRoute = ({ children }) => {
  const currentSubsite = useSelector(getSubsite);
  return (
    <div>
      <EmptyNavBar />
      {children}
      <IgniteFooter menuBgColor={currentSubsite?.menuBgColor} />
    </div>
  ) 
};

export default PublicRoute;